import { applyAuth0Theme } from "@/utils/theme/themeEngine";

import MfaPushChallengeForm from "./components/MfaPushChallengeForm";
import { useMfaPushChallengeManager } from "./hooks/useMfaPushChallengeManager";
import { AuthLayout } from "@/components/auth/AuthLayout";

function MfaPushChallengeScreen() {
    // Extracting attributes from hook made out of MfaPushChallenge instance of Auth0 React ACUL SDK
    const { texts, locales, mfaPushChallengePush } = useMfaPushChallengeManager();

    applyAuth0Theme(mfaPushChallengePush);
    return (
        <AuthLayout title={texts?.pageTitle || locales.page.title}>

            <MfaPushChallengeForm />

        </AuthLayout>
    );
}

export default MfaPushChallengeScreen;
